<template>
  <body>
  <div id="nav_bar_section" class="general_scope sticky_header">
    <div class="section">
      <div id="nav_bar" class="flex_row align_center">
        <div class="logo menu left">
          <a href="" class="flex_row align_center">
            <img src="@/assets/image/logo_lg_light.png" width="115" height="30">
            <span class="padding_left_10px">
            Status
          </span>
          </a>
        </div>
        <div class="menu right">
          <a href="" class="margin_right_25px">Dashboard</a>
          <a href="" class="margin_right_25px">History</a>
        </div>
      </div>
    </div>
  </div>
  <div class="section nav_bar_filler"></div>

    <div class="bg_white width_100" >
      <div id="current_status" class="section align_center justify_content_center">
        <div class="container" v-if="status==200">
          <img class="" src="@/assets/image/Ok.png">
          <h1 class="text_center width_100">LekoTech is up and running</h1>
          <p class="medium text_center off_gray width_100">Having trouble? <a
            href="" class="underline">Troubleshoot
            connection issues</a> or email us at <a href="mailto: info@lekotech.com" class="underline">info@lekotech.com</a>.
          </p>
        </div>
        <div class="container error" v-else>
          <img class="" src="@/assets/image/danger (4).png">
          <h1 class="textError text_center width_100">Users may experience issues accessing or loading LekoTech, have trouble adding new parts, and using LekoTech System.</h1>
          <p class="medium text_center off_gray width_100">Having trouble? <a
            href="" class="underline">Troubleshoot
            connection issues</a> or email us at <a href="mailto: info@lekotech.com" class="underline">info@lekotech.com</a>.
          </p>
        </div>
      </div>
      <div id="services_legend" class="section justify_content_center">
        <div class="header"><p class="title bold">All Systems Operational</p>
          <div class="legend flex_row align_center">
            <div class="flex_row align_center"><img src="@/assets/image/TableCheck.png">
              <p class="tiny off_black">Operational</p></div>
            <div class="flex_row align_center">
              <img src="@/assets/image/icons8-negative-22.png">
              <p class="tiny off_black">Degraded Performance</p></div>
            <div class="flex_row align_center"><img src="@/assets/image/icons8-medium-risk-22.png">
              <p class="tiny off_black">Partial Outage</p></div>
            <div class="flex_row align_center"><img src="@/assets/image/icons8-close-22.png">
              <p class="tiny off_black">Major Outage</p></div>
            <div class="flex_row align_center"><img src="@/assets/image/TableMaintenance.png">
              <p class="tiny off_black">Maintenance</p></div>
          </div>
        </div>
      </div>
      <div class="section">
        <div id="services">
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">LekoTech Login</p>
           </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">Car Wreckers Individual API</p>
             </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">LekoTech Portal Platform</p>
             </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">Multibreves API</p>
              </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">LekoTech Mobile App Usage API</p>
              </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">API</p>
              </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">Standard Endpoints</p>
             </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">LekoTech Shop</p>
        </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">Media Endpoints</p>
             </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>
          <div class="service header align_center">
            <div class="flex_column"><p class="bold">LekotTech Car Wreckers Mobile App</p>
              </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>

          <div class="service header align_center">
            <div class="flex_column"><p class="bold">v2 RESTful Users Endpoints</p>
            </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>

          <div class="service header align_center">
            <div class="flex_column"><p class="bold">FleetNTech Mobile App</p>
            </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>

          <div class="service header align_center">
            <div class="flex_column"><p class="bold">Developer Portal</p>
            </div>
            <div class="flex_row align_center"><img class="" src="@/assets/image/TableCheck.png">
            </div>
          </div>

        </div>
      </div>
      <div id="recent_incidents_legend" class="bg_white width">
        <div class="header section">
          <div class="flex_column"><p class="tiny legend_footer_links"><img src="@/assets/image/Rss.png">
            Subscribe to LekoTech Status updates via <a href="" class="underline">SMS Notification
              </a> or <a href="" class="underline">Push Notifications</a></p></div>
          <div class="flex_column">
            <div class="flex_row flex_right align_center">
              <div class="flex_row margin_right_25px uptime">
                <div><p class="medium">Uptime for the current quarter:</p></div>
                <div class="c-tooltip margin_left_5px"><p class="medium"><span class="underline bold">100%</span></p>
                  <div class="c-tooltip__content v--north v--border-white">
                   </div>
                </div>
              </div>
              <a href="https://lekotech.com/" class="button">SEE HISTORY</a></div>
          </div>
        </div>
      </div>
    </div>


  <footer class="c-nav c-nav--footer">
    <div class="c-nav--footer__menu">
      <div class="o-content-container c-nav--footer__row"><a class="c-nav--footer__link first" href="https://lekotech.com/fleet-management-app/"><img
        class="c-nav--footer__svgicon c-slackhash" src="@/assets/image/car-maintenance-logo.png" width="54" height="54"
        aria-label="Slack Logo"></a>
        <nav class="c-footer--wrap t-contains-subtle-links" role="navigation" aria-label="Footer Navigation">
          <div class="c-nav--footer__block"><p class="c-nav--footer__listheader">Product</p>
            <ul class="c-nav--footer__list">
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/">Why LekoTech?</a></li>
              <li class="c-nav--footer__listitem"><a href="">Customer Stories</a></li>
              <li class="c-nav--footer__listitem"><a href="">LekoTech Demo</a></li>
            </ul>
          </div>
          <div class="c-nav--footer__block"><p class="c-nav--footer__listheader">E-COMMERCE</p>
            <ul class="c-nav--footer__list">
                <li class="c-nav--footer__listitem"><a href="https://lekotech.com/">B2B and B2C E-Commerce</a></li>
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/">Customer Support</a>
              </li>
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/">Sales</a></li>
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/request-a-demo/">Marketing</a></li>
            </ul>
          </div>
          <div class="c-nav--footer__block"><p class="c-nav--footer__listheader">FLEET MANAGEMENT APP</p>
            <ul class="c-nav--footer__list">
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/fleet-management-app/">Download FleetNTech</a></li>
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/fleet-management-app/#">API</a></li>
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/about-us/">Partners</a></li>
            </ul>
          </div>
          <div class="c-nav--footer__block"><p class="c-nav--footer__listheader">Company</p>
            <ul class="c-nav--footer__list">
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/about-us/">About Us</a></li>
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/about-us/">Leadership</a></li>
              <li class="c-nav--footer__listitem"><a href="https://lekotech.com/request-a-demo/">News</a></li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div class="c-nav--footer__metasocial" role="contentinfo">
      <div class="o-content-container">
        <ul class="c-nav__list">
          <li class="c-nav--footer__listitem--meta v--center"><a href="https://lekotech.com/privacy-policy/">Privacy &amp; Terms</a>
          </li>
          <li class="c-nav--footer__listitem--meta v--center"><a href="https://lekotech.com/contact/">Contact Us</a>
          </li>
        </ul>
        <ul class="c-nav__list">
          <li class="c-nav--footer__listitem--social"><a target="_blank" rel="noopener"
                                                         href="https://www.facebook.com/lekotech2019/"><img
            class="c-nav--footer__svgicon" src="@/assets/image/icon_social_facebook_square.svg" width="20" height="20"
            aria-label="Facebook Logo"></a></li>
          <li class="c-nav--footer__listitem--social"><a target="_blank" rel="noopener"
                                                         href="https://www.instagram.com/lekotech2020/"><img
            class="c-nav--footer__svgicon" src="@/assets/image/icons8-instagram.svg" width="20" height="20"
            aria-label="Facebook Logo"></a></li>
          <li class="c-nav--footer__listitem--social"><a target="_blank" rel="noopener"
                                                         href="https://www.youtube.com/@LekoTech"><img
            class="c-nav--footer__svgicon" src="@/assets/image/icon_social_youtube.svg" width="20" height="20"
            aria-label="Youtube Logo"></a></li>
          <li class="c-nav--footer__listitem--social"><a target="_blank" rel="noopener"
                                                         href="https://www.linkedin.com/company/leko-tech/about/"><img
            class="c-nav--footer__svgicon" src="@/assets/image/icon_social_linkedin.svg" width="20" height="20"
            aria-label="LinkedIn Logo"></a></li>
        </ul>
      </div>
    </div>
  </footer>
  </body>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  data(){
    return {
      status: null,
    }
  },
  created(){
    this.getCode();
  },
  methods: {
    getCode(){
      axios.get("https://api.lekotech.com/")
        .then((response) => {
          this.status = response.status;

        });
    }
  },
}
</script>

<style>
@import "/assets/css/style.css";
.error{
  padding-top: 30px;
  padding-bottom: 40px;
}
.textError{
  font-weight: bold;
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue